import React, { useState } from 'react';
import Code from '../components/Code.jsx';

const FEATURES = [
  ['Stage and timeline', 'layers, keyframes, tweens, onion skin, symbols with their own clocks'],
  ['Inspector and library', 'every property of the document, assets and symbols'],
  ['Tracer', 'turns an image into vector layers: levels, colours, smoothing, transparency'],
  ['Bones', 'Armatures, bound symbols and skinned shapes'],
  ['3D and camera', 'rotation_x, rotation_y and z under a perspective, a keyed camera'],
  ['Scripts', 'a TypeScript editor for PulseScript, type-checked, with an Output panel'],
  ['Publish', 'MP4, WebM, GIF, PNG frames, sprite sheets, .pulse and a standalone HTML page'],
];

export default function StudioSection() {
  const [open, setOpen] = useState(false);
  return (
    <section className="sec" id="studio" aria-labelledby="studio-h">
      <div className="wrap">
        <header className="sec-head">
          <p className="kicker">Pulse Studio</p>
          <h2 id="studio-h">A timeline animation editor that runs in the page.</h2>
          <p className="sec-lead">
            Studio edits the same scene document the runtime plays. It mounts inside any element with
            <code>mountStudio(rootEl, {'{'}host, doc{'}'})</code>, so a host application supplies saving and
            assets. It is in active development. The embed below opens the bones demo from further down
            this page; your edits stay in this browser.
          </p>
        </header>
        <div className={`studio-grid ${open ? 'is-open' : ''}`}>
          <div className={`studio-frame wx-stage ${open ? 'is-open' : ''}`}>
            {open ? (
              <iframe title="Pulse Studio editing the bones demo" src="/studio/index.html?doc=demo.json" loading="lazy" />
            ) : (
              <div className="studio-launch">
                <p className="studio-launch-title">Pulse Studio</p>
                <p className="studio-launch-sub">About 1.2 MB of editor, loaded only when you ask for it. Best on a desktop screen.</p>
                <button type="button" className="wx-btn wx-btn--primary wx-btn--pill" onClick={() => setOpen(true)}>Open Studio here</button>
                <a className="linkish" href="/studio/index.html?doc=demo.json" target="_blank" rel="noopener noreferrer">or in a new tab</a>
              </div>
            )}
          </div>
          <div className="studio-side">
            <ul className="feat-list">
              {FEATURES.map(([t, d]) => <li key={t}><b>{t}</b><span>{d}</span></li>)}
            </ul>
            <h3 className="mini-h">Get it</h3>
            <Code label="Run Studio from the repository">{`# in a checkout of pulse-player (source on GitFoundry, private for now)
npm install
npm run studio            # the editor on a local server`}</Code>
            <Code label="Mount Studio in your own page">{`import { mountStudio } from './dist/studio/studio.js';

const studio = mountStudio(document.querySelector('#editor'), {
  host: { load, save, assets, publish },   // your app's storage
  doc,                                     // the scene to open
});`}</Code>
          </div>
        </div>
      </div>
    </section>
  );
}
